import React, { useState } from 'react';

import { Button } from '@host/components/NewUI/ComponentsLibrary';

import Layout from './components/Layout';
import PortalBackButton from './components/PortalBackButton';
import PortalCard from './components/PortalCard';
import PortalFooter from './components/PortalFooter';
import SignaturePad from './components/SignaturePad';
import { palette } from './styles';
import { onboardColors } from '../theme/onboardTokens';

interface Props {
  offerTitle: string;
  onBack: () => void;
  onConfirm: (signatureData: string) => Promise<void>;
}

const OfferSign: React.FC<Props> = ({ offerTitle, onBack, onConfirm }) => {
  const [signature, setSignature] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    if (!signature) {
      setError('Please provide your signature first.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm(signature);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to sign');
      setSubmitting(false);
    }
  };

  return (
    <Layout title={offerTitle || 'Offering letter'}>
      <PortalCard>
        <div style={{ marginBottom: 24 }}>
          <PortalBackButton label="Back to offer" onClick={onBack} />
        </div>

        <h2
          style={{
            color: palette.headingNeutral,
            fontSize: 24,
            margin: '0 0 8px',
            textAlign: 'center'
          }}
        >
          Sign your offer
        </h2>
        <p
          style={{
            color: palette.bodyNeutral,
            fontSize: 14,
            margin: '0 0 24px',
            textAlign: 'center'
          }}
        >
          By signing below, you agree to the terms of the offer.
        </p>

        <div
          style={{
            maxWidth: 400,
            margin: '0 auto',
            border: `1px solid ${palette.divider}`,
            borderRadius: 6,
            padding: '24px',
            background: onboardColors.surface.white
          }}
        >
          <p
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: palette.black,
              textAlign: 'center',
              margin: '0 0 16px'
            }}
          >
            Please sign the offer here
          </p>
          <SignaturePad onChange={setSignature} />
        </div>

        {error ? (
          <p style={{ color: palette.warning, fontSize: 14, marginTop: 16, textAlign: 'center' }}>
            {error}
          </p>
        ) : null}
      </PortalCard>

      <PortalFooter>
        <Button
          buttonVariant="primary"
          disabled={submitting || !signature}
          id="portal-confirm-sign-button"
          onClick={confirm}
        >
          {submitting ? 'Signing…' : 'Confirm & Sign'}
        </Button>
      </PortalFooter>
    </Layout>
  );
};

export default OfferSign;
